import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { AccimotoProposal } from '@/types/api/accimoto';

/**
 * Proposition expirée (maquette AMODEV-33214 « Si expiré ») : le client garde son réparateur. Le lien
 * vers l'ajout du réparateur ouvre l'espace assuré, donc passe par la connexion.
 */
const AccimotoExpiredCard = ({ proposal }: { proposal: AccimotoProposal }) => (
    <Card>
        <CardHeader>
            <CardTitle>La période de réponse est désormais terminée.</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
            <p>Nous n'avons pas reçu votre choix dans le délai prévu.</p>
            <p>La proposition de prise en charge de votre véhicule par Accimoto n'est donc plus disponible.</p>
            <p>Votre dossier poursuit désormais son traitement selon le parcours habituel.</p>
            <p>
                Nous vous invitons à faire transférer votre véhicule vers le réparateur de votre choix afin d'éviter les
                frais de gardiennage et permettre la poursuite de sa gestion.
            </p>
            {proposal.contract_id !== null && (
                <div className="text-center">
                    <Button asChild>
                        <Link
                            to={`/mes-sinistres/contrat/${proposal.contract_id}/sinistre/${proposal.accident_id}/ajouter-reparateur`}
                        >
                            Je renseigne mon réparateur
                        </Link>
                    </Button>
                </div>
            )}
            <p>
                Pour le rapatriement de votre véhicule vers votre réparateur, contactez notre partenaire Mondial
                Assistance : 01 49 93 65 82
            </p>
        </CardContent>
    </Card>
);

export default AccimotoExpiredCard;
